import { graphql } from 'gatsby';
import React from 'react';

import BlockList from '~/components/BlockList';

const ReusableBlock = ({ data }) => {
    const { wpReusableBlock } = data;

    if (wpReusableBlock) {
        const { blocks } = wpReusableBlock;
        return <BlockList {...{ blocks }} />;
    }

    return null;
};

export default ReusableBlock;

export const query = graphql`
    query ReusableBlock($id: String!) {
        wpReusableBlock(id: { eq: $id }) {
            slug
            blocks {
                ...BlockListFragment
            }
        }
    }
`;
